import { EmployeeWithProfile } from "@/pages/OrgChartPage";
import { OrgChartFreeform } from "./OrgChartFreeform";

interface OrgChartProps {
  employees: EmployeeWithProfile[];
  onEmployeeUpdate: () => void;
}

export function OrgChart({ employees, onEmployeeUpdate }: OrgChartProps) {
  return (
    <OrgChartFreeform 
      employees={employees} 
      onEmployeeUpdate={onEmployeeUpdate} 
    />
  );
}
